/* webs.a.medida — Noche eléctrica: interacciones y animaciones */
(function () {
  'use strict';
  var d = document, root = d.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = root.classList.contains('shopify-design-mode');
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function ready(fn) { if (d.readyState !== 'loading') fn(); else d.addEventListener('DOMContentLoaded', fn); }
  function $$(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

  function scroller() {
    var pw = d.querySelector('.page-wrapper');
    if (pw) {
      var cs = getComputedStyle(pw);
      if (/(auto|scroll)/.test(cs.overflowY) && pw.scrollHeight > pw.clientHeight + 5) return pw;
    }
    return d.scrollingElement || root;
  }

  /* Palabra giratoria del titular */
  function rotators() {
    $$('.wb-rotator').forEach(function (r) {
      var list = r.querySelector('.wb-rotator__list');
      if (!list || list.children.length < 2) return;
      var i = 0, n = list.children.length;
      setInterval(function () {
        i = (i + 1) % n;
        list.style.transform = 'translateY(-' + (i * 100 / n).toFixed(4) + '%)';
      }, 2300);
    });
  }

  if (reduce || design) { root.classList.remove('wb-js', 'wb-cover'); return; }

  /* ---------- Portal circular ---------- */
  var portal;
  function makePortal() {
    portal = d.createElement('div');
    portal.className = 'wb-portal is-full';
    portal.setAttribute('aria-hidden', 'true');
    portal.innerHTML = '<span class="wb-portal__mark">webs.a.medida</span>';
    d.body.appendChild(portal);
    root.classList.remove('wb-cover');
  }

  function enter(done) {
    var first = !ss('wb-seen');
    ss('wb-seen', '1');
    setTimeout(function () {
      if (first) portal.classList.add('is-intro');
      setTimeout(function () {
        portal.classList.remove('is-full', 'is-intro');
        done();
      }, first ? 1000 : 60);
    }, 30);
  }

  function bindLeave() {
    d.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || a.target === '_blank' || a.hasAttribute('download')) return;
      var href = a.getAttribute('href') || '';
      if (!href || href.charAt(0) === '#' || /^(javascript|mailto|tel):/.test(href)) return;
      var url;
      try { url = new URL(a.href, location.href); } catch (err) { return; }
      if (url.origin !== location.origin) return;
      if (url.pathname === location.pathname && url.search === location.search) return;
      if (a.closest('[data-no-wb], dialog, cart-drawer-component, .cart-drawer')) return;
      e.preventDefault();
      portal.style.setProperty('--cx', e.clientX + 'px');
      portal.style.setProperty('--cy', e.clientY + 'px');
      root.classList.add('wb-leaving');
      setTimeout(function () { location.href = url.href; }, 620);
    });
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) { root.classList.remove('wb-leaving'); portal.classList.remove('is-full'); }
    });
  }

  /* ---------- Letras que rebotan ---------- */
  function splitChars(el) {
    var i = 0;
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (child) {
        if (child.nodeType === 3) {
          var frag = d.createDocumentFragment();
          child.textContent.split(/(\s+)/).forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(d.createTextNode(' ')); return; }
            var word = d.createElement('span');
            word.className = 'wb-word';
            Array.prototype.forEach.call(part, function (ch) {
              var c = d.createElement('span');
              c.className = 'wb-char';
              c.textContent = ch;
              c.style.setProperty('--ci', (i++ * 32) + 'ms');
              word.appendChild(c);
            });
            frag.appendChild(word);
          });
          child.parentNode.replaceChild(frag, child);
        } else if (child.nodeType === 1 && child.tagName !== 'BR' && !child.classList.contains('wb-rotator') && !child.classList.contains('wb-grad')) {
          walk(child);
        }
      });
    })(el);
  }

  /* ---------- Revelado al hacer scroll ---------- */
  var pending = [];
  function reveal(el) { el.classList.add('is-in'); }
  function check() {
    var vh = window.innerHeight || root.clientHeight;
    pending = pending.filter(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.9 && r.bottom > 0) { reveal(el); return false; }
      return true;
    });
  }

  function setupReveal() {
    $$('[data-wb-chars]').forEach(splitChars);
    $$('[data-wb-stagger]').forEach(function (c) {
      var kids = Array.prototype.filter.call(c.children, function (k) { return k.hasAttribute('data-wb'); });
      kids.forEach(function (k, i) { k.style.setProperty('--d', Math.min(i, 8) * 90 + 'ms'); });
    });
    pending = $$('[data-wb], [data-wb-chars]');
    root.classList.add('wb-ok');
    check();
    var poll = setInterval(function () { check(); if (!pending.length) clearInterval(poll); }, 500);
    setTimeout(function () { pending.forEach(reveal); pending = []; }, 6000);
  }

  /* ---------- Línea de pasos que se llena ---------- */
  function steps() {
    var vh = window.innerHeight || root.clientHeight;
    $$('.wb-steps').forEach(function (s) {
      var r = s.getBoundingClientRect();
      var p = clamp((vh * 0.7 - r.top) / Math.max(r.height, 1), 0, 1);
      s.style.setProperty('--p', p.toFixed(3));
      var items = $$('.wb-step', s);
      items.forEach(function (it, i) {
        var at = items.length > 1 ? i / (items.length - 1) : 0;
        it.classList.toggle('is-lit', p > 0.02 && p >= at * 0.92);
      });
    });
  }

  /* ---------- Botón de volver arriba con progreso ---------- */
  var topBtn, ring;
  function makeTop() {
    topBtn = d.createElement('button');
    topBtn.type = 'button';
    topBtn.className = 'wb-top';
    topBtn.setAttribute('aria-label', 'Volver arriba');
    topBtn.innerHTML = '<svg viewBox="0 0 54 54" aria-hidden="true"><circle cx="27" cy="27" r="24" class="wb-top__track"></circle><circle cx="27" cy="27" r="24" class="wb-top__bar"></circle><path d="M27 34V20M20 26l7-7 7 7" class="wb-top__arrow"></path></svg>';
    d.body.appendChild(topBtn);
    ring = topBtn.querySelector('.wb-top__bar');
    topBtn.addEventListener('click', function () {
      var s = scroller();
      if (s === d.scrollingElement || s === root) window.scrollTo({ top: 0, behavior: 'smooth' });
      else s.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
  function progress() {
    var s = scroller();
    var max = s.scrollHeight - s.clientHeight;
    var y = s.scrollTop || window.scrollY || 0;
    var p = max > 0 ? clamp(y / max, 0, 1) : 0;
    ring.style.strokeDashoffset = (150.8 * (1 - p)).toFixed(1);
    topBtn.classList.toggle('is-on', y > 500);
    var hb = d.querySelector('.wb-hero .wb-blobs');
    if (hb) hb.style.transform = 'translateY(' + (y * 0.25).toFixed(1) + 'px)';
  }

  var queued = false;
  function onScroll() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; check(); steps(); progress(); });
  }

  /* ---------- Foco de luz y cursor ---------- */
  function pointer() {
    if (!fine) return;
    var spot = d.createElement('div');
    spot.className = 'wb-spot';
    spot.setAttribute('aria-hidden', 'true');
    var cur = d.createElement('div');
    cur.className = 'wb-cursor';
    cur.setAttribute('aria-hidden', 'true');
    d.body.appendChild(spot);
    d.body.appendChild(cur);
    var mx = innerWidth / 2, my = innerHeight / 2, cx = mx, cy = my;
    d.addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      spot.style.setProperty('--sx', mx + 'px');
      spot.style.setProperty('--sy', my + 'px');
      cur.classList.add('is-on');
      var t = e.target.closest && e.target.closest('a, button, label, select, summary, input[type="submit"]');
      cur.classList.toggle('is-link', !!t);
    }, { passive: true });
    d.addEventListener('mouseleave', function () { cur.classList.remove('is-on'); });
    d.addEventListener('mousedown', function () { cur.classList.add('is-down'); });
    d.addEventListener('mouseup', function () { cur.classList.remove('is-down'); });
    (function loop() {
      cx += (mx - cx) * 0.18; cy += (my - cy) * 0.18;
      cur.style.transform = 'translate(' + cx.toFixed(1) + 'px,' + cy.toFixed(1) + 'px)';
      requestAnimationFrame(loop);
    })();
  }

  /* ---------- Botones magnéticos ---------- */
  function magnetic() {
    if (!fine) return;
    $$('.wb-btn, .wb-tabs label, .wb-filter a').forEach(function (b) {
      b.addEventListener('mousemove', function (e) {
        var r = b.getBoundingClientRect();
        var x = e.clientX - r.left - r.width / 2;
        var y = e.clientY - r.top - r.height / 2;
        b.style.transform = 'translate(' + (x * 0.22).toFixed(1) + 'px,' + (y * 0.32).toFixed(1) + 'px)';
      });
      b.addEventListener('mouseleave', function () { b.style.transform = ''; });
    });
  }

  /* ---------- Tarjetas 3D con brillo ---------- */
  function tilt() {
    if (!fine) return;
    $$('.wb-tilt').forEach(function (el) {
      el.addEventListener('mousemove', function (e) {
        if (!el.classList.contains('is-in') && el.hasAttribute('data-wb')) return;
        var r = el.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
        el.style.transition = 'transform .15s ease-out, border-color .3s';
        el.style.transform = 'perspective(900px) rotateX(' + ((0.5 - py) * 7).toFixed(2) + 'deg) rotateY(' + ((px - 0.5) * 9).toFixed(2) + 'deg) translateY(-6px)';
        el.style.setProperty('--gx', (px * 100).toFixed(1) + '%');
        el.style.setProperty('--gy', (py * 100).toFixed(1) + '%');
      });
      el.addEventListener('mouseleave', function () {
        el.style.transition = 'transform .7s cubic-bezier(.16,1,.3,1), border-color .3s';
        el.style.transform = '';
      });
    });
  }

  ready(function () {
    makePortal();
    makeTop();
    bindLeave();
    rotators();
    pointer();
    magnetic();
    tilt();
    d.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('resize', onScroll, { passive: true });
    enter(function () { setupReveal(); steps(); progress(); });
  });
})();